import { render, staticRenderFns } from "./MyTagsAssetEditor.vue?vue&type=template&id=9ad3f13c&"
import script from "./MyTagsAssetEditor.vue?vue&type=script&lang=js&"
export * from "./MyTagsAssetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports